import React from 'react';
import { FormattedMessage } from 'react-intl';

import MainLayout from 'components/presenters/layouts/main/MainLayout';
import NoContent from 'components/widgets/NoContent/NoContent';
import routes from 'routesPaths';

import GridUpdatingHook from '../components/GridUpdatingHook/GridUpdatingHook';
import { COMPONENT_NAME } from '../constants';

import RentalsGridContainer from './components/RentalsGridContainer/RentalsGridContainer';
import { useRentalsGrid } from './hooks/useRentalsGrid/useRentalsGrid';

import styles from './RentalsGrid.module.scss';

function RentalsGrid() {
  const { settings, data, wrapperRef, notValidPageTitle, setForceUpdate } = useRentalsGrid();

  const shouldShowNoContent = !settings || !data;

  if (shouldShowNoContent) {
    return (
      <MainLayout>
        <NoContent title={notValidPageTitle} />
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <GridUpdatingHook setForceUpdate={setForceUpdate} path={routes.rentalsGrid.path} />
      <div ref={wrapperRef} className={styles.wrapper}>
        <FormattedMessage
          defaultMessage={settings.title}
          id={`${COMPONENT_NAME}.title.${settings.title}`}
          tagName='h3'
        />
        <RentalsGridContainer data={data} settings={settings} />
      </div>
    </MainLayout>
  );
}

export default React.memo(RentalsGrid);
